__turbopack_context__.v({
  "card": "Card-module-scss-module__XSjb6G__card",
});
